// 알림 중복 표출 차단 — 같은 이벤트가 폴링 완료 토스트와 푸시 notificationReceived 토스트로
// 두 번 뜨는 것을 막는다. 세션(앱 실행) 단위 메모리 Set이면 충분 — 재실행 시 초기화돼도
// 그 시점엔 이미 결과를 본 뒤라 무해하다.
const shown = new Set<string>();
const key = (kind: string, refId: string) => `${kind}:${refId}`;

export function markShown(kind: string, refId: string): void {
  shown.add(key(kind, refId));
}

export function wasShown(kind: string, refId: string): boolean {
  return shown.has(key(kind, refId));
}

export function clearShown(): void { // 테스트용
  shown.clear();
}
